export enum StoreLocatorTabs {
  Nearby,
  Favorites,
  Recent,
  Delivery,
}
